import React, { Component } from 'react';
export default class GroupMembers extends Component{
    
    render() {
        console.log("group_data",this.props.group_data)
        return (
            <div>
                {this.props.group_members ? 
                <div class="tab-system-details second-tab-system-details addtab-system-details">
                {(this.props.group_members.primary_member && this.props.group_members.primary_member.length > 0) ? 
                        this.props.group_members.primary_member.map((data, sequence) =>
                        <div class="row mt20">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" id={`dept_${data.id}`}>
                                    <div class="border-bottom pb20">
                                        <div class="all-box">
                                            <a href={"/viewGroups/"+ data.email} class="tab-title mb20">{data.name}</a>
                                            <div class="row member_row">
                                            {console.log(17,data)}
                                                {data.member && data.member.map((group_data, sequence) =>
                                                        <div class={`col-xs-12 col-sm-3 col-md-3 col-lg-3 mb20 emp_${group_data.id} group-member tooltips`}>
                                                            <div class="tooltiptext">
                                                                <div class="tip_name">{group_data.name}</div>
                                                                <div class="tip_position">{group_data.position}</div>
                                                            </div>
                                                            <div class="details-box mb10 mln-10">
                                                                <div class="img-box">
                                                                    <img src={group_data.attachment}/>
                                                                    {this.props.hr_permission == 'yes' && !this.props.fromTroop ?
                                                                    <div class="boxing-close"  title="Remove"  data-toggle="modal" data-target="#deleteEmployee" onClick={() => this.props.parent.showRemoveEmployeeModal(this.props.group_data.id,this.props.group_data.name,group_data.name,data.group_type,group_data.id)}>
                                                                        <i class="fal fa-times" ></i>
                                                                    </div>:''}
                                                                </div>
                                                                <div class="box-item">
                                                                    <a href={"/viewEmployee/"+ group_data.id} class="name">{group_data.name && group_data.name.length > 20 ? group_data.name.substring(0,20)+"...":group_data.name}</a>
                                                                    <div class="designation">{group_data.position && group_data.position.length > 20 ? group_data.position.substring(0,20)+"...":group_data.position}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )
                : "" }
                <div>
                {console.log(43,this.props.group_members)}
                {this.props.group_members['listener'] ? 
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt20">
                        <div class="all-box">
                            <div class="tab-title mb20">Listener</div>
                            <div class="row">
                            {
                                this.props.group_members['listener'].map((data, sequence) =>
                                    <div class={`col-xs-12 col-sm-3 col-md-3 col-lg-3 emp_${data.id} group-member tooltips`}>
                                        <div class="tooltiptext">
                                            <div class="tip_name">{data.name}</div>
                                            <div class="tip_position">{data.position}</div>
                                        </div>
                                        <div class="details-box mb20">
                                            <div class="img-box">
                                                <img src={data.attachment}/>
                                                {this.props.hr_permission == 'yes' && !this.props.fromTroop ?
                                                <div class="boxing-close" title = "Remove Employee" data-toggle="modal" data-target="#deleteEmployee" onClick={() => this.props.parent.showRemoveEmployeeModal(this.props.group_data.id,this.props.group_data.name,data.name,0,data.id)} >
                                                    <i class="fal fa-times" ></i>
                                                </div>
                                                :''}
                                            </div>
                                            <div class="box-item">
                                                <a href={"/viewEmployee/"+ data.id} class="name">{data.name && data.name.length > 20 ? data.name.substring(0,20)+"...":data.name}</a>
                                                <div class="designation">{data.position && data.position.length > 20 ? data.position.substring(0,20)+"...":data.position}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            </div>
                        </div>
                    </div>
                : "" }
                </div>
                </div>
                : ""}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/hrAdmin/GroupsMembers.js